import React, { useContext } from 'react';
import { Clickable } from 'src/components/clickable';
import type { PrismicSliceCallToAction } from 'src/types';
import { CallToActionContainer, CallToActionButton } from './styles';
import { AppContext } from 'src/components/app-context';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = Pick<PrismicSliceCallToAction, 'buttonTitle' | 'buttonUrl'>;

const isAbsoluteUrl = (url: string) => url.startsWith('http');
const isExternalLink = (url: string, siteUrl?: string) =>
  isAbsoluteUrl(url) && getLinkHostname(url) !== getLinkHostname(siteUrl || '');
const getLinkHostname = (url: string) =>
  isAbsoluteUrl(url) ? new URL(url).host : undefined;
const getLinkPath = (url: string) =>
  isAbsoluteUrl(url) ? new URL(url).pathname : url;

const CallToAction = ({ buttonTitle, buttonUrl }: Props) => {
  const { market } = useContext(AppContext);
  const isExternal = isExternalLink(buttonUrl, market.sites.production);
  const toLink = isExternal ? buttonUrl : getLinkPath(buttonUrl);
  return (
    <CallToActionContainer>
      <CallToActionButton
        container={Clickable}
        containerProps={{
          isExternal,
          to: toLink,
          containerProps: {
            target: isExternal ? '_blank' : undefined,
            onClick: () =>
              trackInternalNavigationClick({
                scope: InternalNavigationScope.CALL_TO_ACTION,
                nextPage: toLink,
              }),
          },
        }}
        ariaLabel={buttonTitle}
      >
        {buttonTitle}
      </CallToActionButton>
    </CallToActionContainer>
  );
};

export default CallToAction;
